import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24" }
const _hoisted_7 = {
  key: 0,
  style: {"color":"#ff4d4f","font-size":"12px"}
}
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_11 = {
  key: 0,
  style: {"color":"#ff4d4f","font-size":"12px"}
}
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    centered: "",
    width: 600,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    maskClosable: false
  }, {
    title: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.state.indexEdicao >= 0 ? 'Editar Documento Referenciado' : 'Adicionar Documento Referenciado'), 1)
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "ant-btn ant-btn-lg ant-btn-secondary ss-btn-acao-destaque",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalBase.computedVisivel = false))
      }, _hoisted_2),
      _createElementVNode("button", {
        type: "button",
        class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args)))
      }, _hoisted_4)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_form_item, {
                label: "Chave de Acesso do Documento",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.state.documento.chaveAcessoDocumento,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.documento.chaveAcessoDocumento) = $event)),
                    maxlength: 44,
                    placeholder: "44 dígitos",
                    onPaste: _ctx.tratarCola
                  }, null, 8, ["value", "onPaste"]),
                  (_ctx.state.erroChave)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.state.erroChave), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_a_form_item, {
                label: "Cód. Nota Fiscal de Entrada",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_campo_numerico, {
                    valor: _ctx.state.documento.codigoNotaFiscalEntrada,
                    "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.documento.codigoNotaFiscalEntrada) = $event)),
                    quantidadeCasasDecimais: 0,
                    fracionar: false
                  }, null, 8, ["valor"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_a_form_item, {
                label: "Valor do Documento (R$)",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_campo_numerico, {
                    valor: _ctx.state.documento.valorDocumento,
                    "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.documento.valorDocumento) = $event)),
                    quantidadeCasasDecimais: 2,
                    fracionar: true
                  }, null, 8, ["valor"]),
                  (_ctx.state.erroValor)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.state.erroValor), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_a_form_item, {
                label: "Peso do Documento (kg)",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_campo_numerico, {
                    valor: _ctx.state.documento.pesoDocumento,
                    "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.documento.pesoDocumento) = $event)),
                    quantidadeCasasDecimais: 3,
                    fracionar: true
                  }, null, 8, ["valor"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}